/**
 * Saudi phone validation (+966).
 * Accepts: +9665XXXXXXXX, 9665XXXXXXXX, 05XXXXXXXX, 5XXXXXXXX
 */

const SAUDI_PHONE_REGEX = /^\+966[1-9]\d{8}$/;

/** Normalize to E.164 +966XXXXXXXXX */
export function normalizeSaudiPhone(raw) {
  if (raw == null) return '';
  let digits = String(raw).replace(/[\s\-().]/g, '');
  if (!digits) return '';

  if (digits.startsWith('+')) digits = digits.slice(1);
  if (digits.startsWith('00966')) digits = digits.slice(5);
  else if (digits.startsWith('966')) digits = digits.slice(3);
  else if (digits.startsWith('0')) digits = digits.slice(1);

  if (digits.length === 9) return `+966${digits}`;
  if (digits.length === 12 && digits.startsWith('966')) return `+${digits}`;
  if (String(raw).trim().startsWith('+966') && digits.length >= 12) {
    return `+966${digits.slice(-9)}`;
  }
  return String(raw).trim();
}

export function isValidSaudiPhone(raw) {
  const normalized = normalizeSaudiPhone(raw);
  return SAUDI_PHONE_REGEX.test(normalized);
}

export function formatSaudiPhoneDisplay(raw) {
  const n = normalizeSaudiPhone(raw);
  if (!SAUDI_PHONE_REGEX.test(n)) return raw != null ? String(raw).trim() : '';
  const local = n.slice(4);
  return `+966 ${local.slice(0, 2)} ${local.slice(2, 5)} ${local.slice(5)}`;
}

export const SAUDI_PHONE_PLACEHOLDER = '+966 5X XXX XXXX';

export default { normalizeSaudiPhone, isValidSaudiPhone, formatSaudiPhoneDisplay, SAUDI_PHONE_PLACEHOLDER };
